<template>
    <ImpedimentContainer
        title="AUT-Autismo"
    >
        <p><b>El estudiante presenta:</b></p>
        <TreeOptions
            v-model="optionsTree"
            :is-disabled="isDisabled"
            :show-error="showErrors && !isValid"
        />
        <div class="disorders__container">
            <ValidationProvider
                v-slot="{ errors }"
                mode="eager"
                name="disorders"
                rules="required"
            >
                <CustomDropDown
                    id="disorders"
                    v-model="innerModel.disorders"
                    label="Trastorno:"
                    custom-error-msg="Favor de seleccionar el trastorno generalizado del desarrollo. (21046)"
                    :error="errors[0]"
                    placeholder="Seleccione"
                    fieldkey="id"
                    fieldname="name"
                    :options="disordersOptions"
                    :disabled="isDisabled"
                />
            </ValidationProvider>
        </div>
    </ImpedimentContainer>
</template>
  
<script>
import TreeOptions from './options/TreeOptions.vue';
import ImpedimentMixin from './common/ImpedimentMixin';
import ImpedimentContainer from './common/ImpedimentContainer';
import { ValidationProvider } from 'vee-validate';
import { CustomDropDown } from '@/components/common';

export default {
    name: 'Autismo',
    mixins: [ImpedimentMixin],
    components: {
        TreeOptions,
        ImpedimentContainer,
        ValidationProvider,
        CustomDropDown
    },
    props: {
        value: {
            type: Object,
            default: () => ({
                severity: null
            })
        },
        disordersOptions: {
            type: Array,
            default: () => []
        }
    },
    data: () => ({
        showErrors: false,
    }),
    methods: {
        validate() {
            this.showErrors = true;
            return this.isValid;
        }
    },
    computed: {
        isValid() {
            return this.isValidOptionsSelection;
        }
    },
    watch: {
        value: {
            deep: true,
            immediate: true,
            handler(newValue) {
                this.innerModel = newValue;
            }
        },
        innerModel: {
            deep: true,
            handler(newValue) {
                this.$emit('input', newValue);
            }
        },
    }
}
</script>

<style scoped>
.disorders__container {
    width: 20vw;
}
</style>